import { utmOf, utmQuery } from "@fusiqo/vozqi-shared";
import { detectPlatform } from "../lib/platform";
import { apiBaseOrNull, storeHref } from "../lib/store-link";
import { BrandLogo } from "../ui/brand-logo";
import { StoreBadges } from "../ui/store-badges";
// oxlint-disable-next-line import/no-unassigned-import -- the awning and the button are the profile's, imported for their side effect
import "./profile.css";
// oxlint-disable-next-line import/no-unassigned-import -- the foot's own stylesheet, imported for its side effect
import "./vozqi-foot.css";

const API = apiBaseOrNull();

/**
 * VOZQI'S FOOT, common to the profile and an item's page, promoting VozQI.
 * Under everything the business says, never above it, never fixed:
 * the page is the business's, and «Pedir servicio» and WhatsApp stay its only
 * calls. Two quiet parts -- what VozQI is with its store badges, and the
 * invitation to a visitor who has a business of their own.
 *
 * THE HOUSE'S ATTRIBUTION, nothing new: utm tags on every door (`origin.ts`
 * keeps them on the landing and on the sign-up; the store counter hands them
 * to Play's referrer and the App Store's `ct`). The campaign is the profile's
 * slug, so the panel can tell which business brought the account. A phone
 * sees its own store and the invitation opens it; a computer sees both
 * badges, and the invitation opens the sign-up on the web.
 */
export function VozqiFoot({ slug, page }: { slug: string | null; page: "perfil" | "articulo" }) {
  const tags = utmQuery(
    utmOf({ source: "perfil", medium: "pie", campaign: slug, content: page === "articulo" ? "articulo" : null }),
  );
  const platform = detectPlatform(navigator.userAgent, navigator.maxTouchPoints);
  const phone = platform === "desktop" ? null : platform;
  const store = (which: "ios" | "android"): string => storeHref(API, which, tags);

  return (
    <>
      {/* The page's leftover height, never less than a breath above the foot's line. */}
      <div className="vozqi-foot-space" aria-hidden="true" />
      <footer className="vozqi-foot">
      <div className="vozqi-foot-inner">
        <div className="vozqi-brand">
          <a className="vozqi-brand-mark" href={`/?${tags}`}>
            Hecho con <BrandLogo height={18} />
          </a>
          <p className="vozqi-brand-line">
            La app para llevar las ventas, los cobros y los clientes de tu negocio desde el celular.
          </p>
          <StoreBadges {...(phone === null ? {} : { platform: phone })} hrefFor={store} />
        </div>

        <div className="vozqi-invite">
          <span className="profile-awning" aria-hidden="true" />
          <div className="vozqi-invite-body">
            <div>
              <p className="vozqi-invite-title">¿Tienes un negocio?</p>
              <p className="vozqi-invite-text">Regístralo gratis y crea tu perfil para que puedas atraer clientes.</p>
            </div>
            {phone === null ? (
              <a className="profile-button" href={`/auth/sign-up?${tags}`}>
                Crear mi perfil gratis
              </a>
            ) : (
              <a className="profile-button" href={store(phone)} target="_blank" rel="noopener">
                Crear mi perfil gratis
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
    </>
  );
}
